var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 20L14.275 22L19 17.3333M1 22C1 17.4897 4.52576 13.8333 8.875 13.8333C10.5481 13.8333 12.0995 14.3744 13.375 15.2971M13.375 5.66667C13.375 8.244 11.3602 10.3333 8.875 10.3333C6.38972 10.3333 4.375 8.244 4.375 5.66667C4.375 3.08934 6.38972 1 8.875 1C11.3602 1 13.375 3.08934 13.375 5.66667Z",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonTickIcon);
export default __webpack_public_path__ + "static/media/person_tick_icon.33b12010614d7a88c595ee68ec21b676.svg";
export { ForwardRef as ReactComponent };